import { h, Component } from "preact";

import selectTriangle from "./images/select_triangle.svg";

class Collapsible extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openState: props.defaultOpen,
      active: !!props.defaultOpen
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle(e) {
    e.stopPropagation();
    this.setState({
      openState: !this.state.openState,
      active: !this.state.active
    });

    if (this.props.onClick) {
      this.props.onClick();
    }
  }

  render({ children, title, onClick, open }, { openState }) {
    return (
      <div class="user-widget__collapsible">
        <button
          class={`user-widget__collapsible__top_bar ${open && "user-widget__collapsible__top_bar--active"}`}
          onClick={onClick || this.toggle}
          aria-label={title}
        >
          <div>{title}</div>
          <img
            class={`${open && "user-widget__dropdown__icon--open"}`}
            src={selectTriangle}
            alt="chevron"
          />
        </button>
        <div
          class={`user-widget__collapsible__content ${(onClick ? open : openState) &&
            "user-widget__collapsible__content--open"}`}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default Collapsible;



// WEBPACK FOOTER //
// ./src/Collapsible.js